import React from "react";
import CommonRow from "../common-row";
const FourStoryCards = props => {
  return <CommonRow {...props} />;
};

export default FourStoryCards;
